import React from 'react';

export function TopBar({ right }) {
  return (
    <div className="topbar">
      <div className="brand">
        <div className="logo">◎</div>
        <div>
          Smart Vision
          <small>CCTV · Biometric · Electrical</small>
        </div>
      </div>
      {right}
    </div>
  );
}

const STATUS_CLASS = {
  Open: 'b-open', InProgress: 'b-inprogress', Resolved: 'b-resolved', Closed: 'b-closed',
};
const STATUS_LABEL = {
  Open: 'Open', InProgress: 'In Progress', Resolved: 'Resolved', Closed: 'Closed',
};
export function StatusBadge({ status }) {
  return (
    <span className={`badge dot ${STATUS_CLASS[status] || 'b-closed'}`}>
      {STATUS_LABEL[status] || status}
    </span>
  );
}

const PRIO_CLASS = {
  Critical: 'b-critical', High: 'b-high', Medium: 'b-medium', Low: 'b-low',
};
export function PriorityBadge({ priority }) {
  return (
    <span className={`badge ${PRIO_CLASS[priority] || 'b-medium'}`}>
      {priority}
    </span>
  );
}

export function Spinner({ big }) {
  return <div className={big ? 'loading-wrap' : ''}><span className="spinner" /></div>;
}
